import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper/bundle"

export default class extends Controller {
  static targets = ["pagination"]

  connect() {
    const slideCount = this.element.querySelectorAll(".swiper-slide").length
    this.element.classList.toggle("blog-card__swiper--single", slideCount <= 1)

    this.swiper = new Swiper(this.element, {
      slidesPerView: 1,
      speed: 700,
      grabCursor: slideCount > 1,
      resistanceRatio: 0.72,
      pagination: this.hasPaginationTarget ? {
        el: this.paginationTarget,
        clickable: true
      } : undefined
    })
  }

  disconnect() {
    this.swiper?.destroy(true, true)
  }
}
